﻿import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UIText} from "../Tools/Base/UIText";
import {Core} from "../../Base/Core";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";

export class UIOneTimeOfferConfirm extends UICommonPopup {
    Awake() {
        super.Awake({
            title: Core.Localizator.Get("offer_onetime"),
            closeButton: true,
        });

        this.descText = this.content.addChild(new UIText(Core.Localizator.Get("one_time_offer_message")));
        this.confirmBtn = this.content.addChild(new UINineSliceButton("btn-green", { label: Core.Localizator.Get("ok") }));
        this.confirmBtn.on("pointertap", () => {
            Core.UI.firstCreatureOffer.Hide();
            Core.UI.skipEpochsOffer.Hide();
            Core.UI.spinsOffer.Hide();
            this.Hide();
        });
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 0.9;
        let w = Math.min(viewport.width * 0.8, (viewport.height * 0.8) / sideRatio);
        let h = w * sideRatio;

        this.setPopupSize(w, h);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize(true);

        let rect = contentRect.clone();
        rect.width = contentRect.width * 0.9;
        rect.height = contentRect.height * 0.65;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = contentRect.y + (contentRect.height - rect.height) * 0.05;
        this.descText.fitLayout(rect);

        rect.width = contentRect.width * 0.4;
        rect.height = contentRect.height * 0.25;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = contentRect.y + (contentRect.height - rect.height) * 0.95;
        this.confirmBtn.fitLayout(rect);
    }
}
